export default {"src":"/_next/static/media/expressjs.cdf9c902.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};